<script setup>
import { ref } from 'vue'
import VideoItem from '../sliders/videoItem.vue';

const props = defineProps({
   item: String,
})

const videoHeaderItem = {
   url: props.item,
   type: 'video'
}

</script>

<template>
   <div class="videoHeader ">
      <div class="videoHeader__floatBlock">
         <div class="videoHeader__floatBlock__backSideVideoItem">
            <VideoItem :mode="['full_size', 'no_skeleton']" :item="videoHeaderItem" :classItems="['videoItemStyle']" />
         </div>
         <div class="videoHeader__floatBlock__videoItem">
            <VideoItem :mode="['full_size', 'no_skeleton']" :item="videoHeaderItem" :classItems="['videoItemStyle']" />
         </div>
         <div class="videoHeader__floatBlock__botoomFog"></div>
         <div class="videoHeader__floatBlock__botoomFogBig"></div>
         <div class="videoHeader__floatBlock__fullFog"></div>
      </div>
   </div>
</template>

<style lang="scss">
.videoHeader {
   // height: calc(10px + 50vw);
   height: calc(56.25vw - 40px);
   position: relative;

   // .videoHeader__floatBlock
   &__floatBlock {
      position: absolute;
      width: 100%;
      background: var(--app__header_grey_color);
      // height: calc(100% + 60px);
      height: calc(100% + 67px);
      z-index: 0;
      overflow: hidden;

      // .videoHeader__floatBlock__videoItem
      &__videoItem {
         position: absolute;
         z-index: 2;

         height: 100%;
         /* background: var(--app__header_grey_color); */
         width: 100%;
         display: flex;
         justify-content: center;
         align-items: center;
         flex-direction: row;
      }

      // .videoHeader__floatBlock__backSideVideoItem
      &__backSideVideoItem {
         position: absolute;
         top: 0;
         width: 100% !important;
         height: auto;
         filter: blur(35px);
         opacity: 0.33;
         display: flex;
         transform: translateY(-50%);
      }

      // .videoHeader__floatBlock__botoomFog
      &__botoomFog {
         position: absolute;
         z-index: 5;
         bottom: 0;
         height: 42px;
         width: 100%;
         background: linear-gradient(to bottom,
               #00000000 0%,
               var(--app__header_grey_color));
         // background: linear-gradient(#81818100, );
         // background: linear-gradient(to bottom,
         //       rgba(0, 0, 0, 0) 0%,
         //       rgba(0, 0, 0, 0.06) 12%,
         //       var(--app__header_grey_color) 100%);
      }

      // .videoHeader__floatBlock__botoomFogBig
      &__botoomFogBig {
         position: absolute;
         z-index: 6;
         bottom: 0;
         height: 50%;
         width: 100%;
         background: linear-gradient(to bottom, #0000, var(--app__header_grey_color));
      }

      // .videoHeader__floatBlock__fullFog
      &__fullFog {
         position: absolute;
         top: 0;
         height: 100%;
         width: 100%;
         z-index: 5;
         background: transparent;
         /* background: var(--app__header_grey_color); */
         /* opacity: 0.25; */
      }
   }
}
</style>
